/** Shared `{ value, label }` enum entry shape served by the API, as it comes off the wire. */
export type SsoModePayload = {
	readonly value: string;
	readonly label: string;
};

export type SsoModesFetchedPayload = SsoModePayload[];

export type SsoModesFetchedAction = {
	type: 'SSO_MODES_FETCHED';
	payload: SsoModesFetchedPayload;
};

export default (payload: SsoModesFetchedPayload): SsoModesFetchedAction => ({
	type: 'SSO_MODES_FETCHED',
	payload,
});
